var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartialLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18582",
    "data-name": "Group 18582",
    transform: "translate(-125 -69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_42657",
    "data-name": "Rectangle 42657",
    transform: "translate(125 69)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18581",
    "data-name": "Group 18581",
    transform: "translate(15335.949 -11627.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "passkey_FILL0_wght400_GRAD0_opsz24",
    d: "M2.128,6.916l-.8-.8V3.644a1.833,1.833,0,0,1-.958-.658A1.8,1.8,0,0,1,0,1.862,1.794,1.794,0,0,1,.545.545,1.794,1.794,0,0,1,1.862,0,1.794,1.794,0,0,1,3.179.545a1.794,1.794,0,0,1,.545,1.317,1.76,1.76,0,0,1-.339,1.064,1.879,1.879,0,0,1-.858.665l.665.665-.8.8.8.8ZM1.862,2.128A.523.523,0,0,0,2.394,1.6a.523.523,0,0,0-.532-.532A.523.523,0,0,0,1.33,1.6a.523.523,0,0,0,.532.532Z",
    transform: "translate(-15196.549 11704.414) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M7.6,11.055H1.085a1.065,1.065,0,0,1-.766-.309A1,1,0,0,1,0,10V4.738a1,1,0,0,1,.319-.744,1.065,1.065,0,0,1,.766-.309H5.972V2.632A1.508,1.508,0,0,0,5.5,1.513a1.607,1.607,0,0,0-1.154-.46,1.607,1.607,0,0,0-1.154.46,1.508,1.508,0,0,0-.475,1.119H1.629A2.508,2.508,0,0,1,2.423.77,2.67,2.67,0,0,1,4.343,0a2.67,2.67,0,0,1,1.92.77,2.509,2.509,0,0,1,.794,1.862V3.685H7.6a1.065,1.065,0,0,1,.766.309,1,1,0,0,1,.319.744V5.995H7.6V4.738H1.085V10H7.6V9.741l.024.047H8.686V10a1,1,0,0,1-.319.743A1.065,1.065,0,0,1,7.6,11.055ZM4.343,8.423a1.066,1.066,0,0,1-.767-.309,1.025,1.025,0,0,1,0-1.487,1.106,1.106,0,0,1,1.534,0,1.025,1.025,0,0,1,0,1.487A1.066,1.066,0,0,1,4.343,8.423Z",
    transform: "translate(-15209.351 11698.886)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartialLock);
export default __webpack_public_path__ + "static/media/partial_lock.9bace73751c50dc7b3f8a69e6e3d46fe.svg";
export { ForwardRef as ReactComponent };